module.exports = __webpack_public_path__ + "img/b103922.jpg";